import * as React from 'react';
import Svg, { Path } from 'react-native-svg';

const SvgComponent = ({ color, ...props }) => (
    <Svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} fill="none" {...props}>
        <Path fill={color} d="M6.815 9.66 6.34 14.4l6.163-6.637-3.319-1.896.474-4.267-6.163 6.637 3.319 1.422Z" />
    </Svg>
);
export default SvgComponent;
